// src/components/ProductsPage.jsx

// import { useEffect, useState } from "react";
// import { useSearchParams, useNavigate } from "react-router-dom";
// import BackButton from "./BackButton";
// import { useCategories } from "../context/CategoriesContext";
// import { fetchFilters } from "../api/filtersApi";
// import { useCart } from "../context/CartContext";

// export default function ProductsPage() {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [subcategoryName, setSubcategoryName] = useState("");
//   const [loadingPage, setLoadingPage] = useState(true);
//  const { cartItems, addToCart, updateQuantity } = useCart();

//   // Filter states
//   const [isFilterOpen, setIsFilterOpen] = useState(false);
//   const [filterOptions, setFilterOptions] = useState({});
//   const [selectedFilters, setSelectedFilters] = useState({
//     colour_group_name: new Set(),
//     department_name: new Set(),
//     garment_group_name: new Set(),
//     graphical_appearance_name: new Set(),
//     section_name: new Set(),
//   });
//   const [openFilters, setOpenFilters] = useState(new Set());

//   const subcategoryKey = searchParams.get("key");
//   const { categories, loading: loadingCategories } = useCategories();

//   useEffect(() => {
//   // Reset filters when subcategory changes
//   setSelectedFilters({
//     colour_group_name: new Set(),
//     department_name: new Set(),
//     garment_group_name: new Set(),
//     graphical_appearance_name: new Set(),
//     section_name: new Set(),
//   });
//   setOpenFilters(new Set());
// }, [subcategoryKey]);

// // Load filter options on every mount (refresh)
// useEffect(() => {
//   const loadFilters = async () => {
//     try {
//       const data = await fetchFilters(); // Always calls API
//       setFilterOptions(data.filters);
//     } catch (err) {
//       console.error("Failed to load filters", err);
//       // Optional: fallback to last saved or mock data
//     }
//   };
//   loadFilters();
// }, []);

//   useEffect(() => {
//     if (!subcategoryKey || loadingCategories || !categories) return;

//     let found = false;
//     let productList = [];
//     let name = "";

//     for (const category of categories) {
//       for (const sub of category.subcategories) {
//         for (const child of sub.children) {
//           if (child.key === subcategoryKey) {
//             productList = child.products;
//             name = child.value;
//             found = true;
//             break;
//           }
//         }
//         if (found) break;
//       }
//       if (found) break;
//     }

//     if (found) {
//       setProducts(productList);
//       setFilteredProducts(productList);
//       setSubcategoryName(name);
//     } else {
//       setSubcategoryName("Subcategory not found");
//     }

//     setLoadingPage(false);
//   }, [subcategoryKey, categories, loadingCategories]);

//   // Apply filters whenever selectedFilters changes
//   useEffect(() => {
//     if (products.length === 0) return;

//     const filtered = products.filter((product) => {
//       // You'd ideally have product.attributes like:
//       // product.colour, product.department, etc.
//       // For now, we'll simulate filtering on product name (demo)
//       const lowerName = product.name.toLowerCase();

//       for (const [key, values] of Object.entries(selectedFilters)) {
//         if (values.size === 0) continue;

//         const hasMatch = Array.from(values).some((value) =>
//           lowerName.includes(value.toLowerCase())
//         );
//         if (!hasMatch) return false;
//       }
//       return true;
//     });

//     setFilteredProducts(filtered);
//   }, [selectedFilters, products]);

//   const toggleFilter = (group, value) => {
//     setSelectedFilters((prev) => {
//       const newSet = new Set(prev[group]);
//       if (newSet.has(value)) {
//         newSet.delete(value);
//       } else {
//         newSet.add(value);
//       }
//       return { ...prev, [group]: newSet };
//     });
//   };

//   const closeFilterDrawer = () => {
//     setIsFilterOpen(false);
//   };

//   const toggleFilterGroup = (group) => {
//     const newOpenFilters = new Set(openFilters);
//     if (newOpenFilters.has(group)) {
//       newOpenFilters.delete(group);
//     } else {
//       newOpenFilters.add(group);
//     }
//     setOpenFilters(newOpenFilters);
//   };

//   if (loadingCategories || loadingPage) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">Loading products...</p>
//       </div>
//     );
//   }

//   if (!subcategoryKey || products.length === 0) {
//     return (
//       <div className="max-w-screen-xl mx-auto px-4 py-10 text-center">
//         <h2 className="text-2xl text-red-600">{subcategoryName}</h2>
//         <button
//           onClick={() => navigate(-1)}
//           className="mt-4 px-6 py-2 bg-gray-200 hover:bg-gray-300 rounded text-gray-800"
//         >
//           ← Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-screen-xl mx-auto px-4 py-10 relative">
//       <BackButton />

//       <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase tracking-tight">
//         {subcategoryName}
//       </h1>

//       {/* Category Tabs */}
//       <div className="flex flex-wrap gap-2 mb-6">
//         <button className="px-4 py-2 bg-black text-white font-medium text-sm uppercase tracking-wide rounded border border-black">
//           HOODIES & SWEATSHIRTS
//         </button>
//         <button className="px-4 py-2 bg-white text-gray-800 font-medium text-sm uppercase tracking-wide border border-gray-300 hover:bg-gray-100">
//           GRAPHIC HOODIES & SWEATSHIRTS
//         </button>
//       </div>

//       {/* Sort & Filter */}
//       <div className="flex justify-between items-center mb-6">
//         <button className="text-sm font-medium text-gray-700 flex items-center gap-1">
//           SORT BY
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-4 w-4"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M19 9l-7 7-7-7"
//             />
//           </svg>
//         </button>
//         <button
//           className="text-sm font-medium text-gray-700 flex items-center gap-1"
//           onClick={() => setIsFilterOpen(true)}
//         >
//           FILTER
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-4 w-4"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00.293.707L18 17.586V19a1 1 0 01-1 1H7a1 1 0 01-1-1v-1.414l-6.414-6.414A1 1 0 013 12.586V4z"
//             />
//           </svg>
//         </button>
//       </div>

//       {/* Product Grid */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
//         {filteredProducts.map((product) => {
//           const cartItem = cartItems.find((item) => item.id === product.id);
//           const quantity = cartItem ? cartItem.quantity : 0;

//           return (
//             <div
//               key={product.id}
//               className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden relative"
//             >
//               <img
//                 src={product.image}
//                 alt={product.name}
//                 className="w-full h-64 object-cover"
//               />

//               <div className="p-3">
//                 <h3 className="text-sm font-medium text-gray-800 line-clamp-2">
//                   {product.name}
//                 </h3>
//                 <p className="text-blue-600 font-semibold mt-1">
//                   ${product.price}
//                 </p>

//                 {/* Quantity Controls */}
//                 <div className="flex items-center justify-between mt-3">
//                   {quantity === 0 ? (
//                     <button
//                       onClick={() => addToCart(product)}
//                       className="w-full py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded transition-colors"
//                     >
//                       Add to Cart
//                     </button>
//                   ) : (
//                     <div className="flex items-center gap-2 w-full">
//                       <button
//                         onClick={() => updateQuantity(product.id, quantity - 1)}
//                         className="w-8 h-8 bg-gray-200 hover:bg-gray-300 rounded-full flex items-center justify-center text-sm"
//                       >
//                         −
//                       </button>
//                       <span className="flex-1 text-center text-sm font-medium">
//                         {quantity}
//                       </span>
//                       <button
//                         onClick={() => updateQuantity(product.id, quantity + 1)}
//                         className="w-8 h-8 bg-gray-200 hover:bg-gray-300 rounded-full flex items-center justify-center text-sm"
//                       >
//                         +
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//       {/* Filter Drawer */}
// {isFilterOpen && (
//   <div className="fixed inset-0 z-50 flex">
//     {/* Backdrop */}
//     <div className="flex-1 bg-black bg-opacity-50" onClick={closeFilterDrawer} />

//     {/* Sidebar */}
//     <div className="w-80 bg-white h-full shadow-lg p-6 overflow-y-auto">
//       <div className="flex justify-between items-center mb-6">
//         <h2 className="text-lg font-semibold">Filters</h2>
//         <button onClick={closeFilterDrawer} className="text-gray-600">
//           ✕
//         </button>
//       </div>

//       {/* Selected Filter Pills */}
//       {Object.keys(selectedFilters).map((group) =>
//         Array.from(selectedFilters[group]).map((value) => (
//           <span
//             key={`${group}-${value}`}
//             className="inline-flex items-center gap-1 bg-gray-200 text-gray-800 text-xs px-3 py-1 rounded-full mr-2 mb-2"
//           >
//             {value}
//             <button
//               type="button"
//               onClick={() => toggleFilter(group, value)}
//               className="text-gray-500 hover:text-gray-700"
//             >
//               ✕
//             </button>
//           </span>
//         ))
//       )}

//       {/* Show "No filters selected" placeholder if none */
//         Object.values(selectedFilters).every(set => set.size === 0) && (
//           <p className="text-sm text-gray-500 mb-6">No filters selected</p>
//         )}

//       {/* Collapsible Filter Groups */}
//       {Object.keys(filterOptions).map((group) => {
//         const displayName = group
//           .replace(/_/g, " ")
//           .replace(/\b\w/g, (l) => l.toUpperCase());
//         const isOpen = openFilters.has(group);

//         return (
//           <div key={group} className="border-t border-gray-200 pt-4">
//             {/* Filter Heading */}
//             <button
//               type="button"
//               className="flex justify-between w-full font-medium text-gray-800 text-sm uppercase tracking-wide"
//               onClick={() => toggleFilterGroup(group)}
//             >
//               {displayName}
//               <span className="text-gray-500 transform transition-transform duration-200">
//                 {isOpen ? "−" : "+"}
//               </span>
//             </button>

//             {/* Filter Options (only if open) */}
//             {isOpen && (
//               <div className="mt-3 space-y-2 max-h-60 overflow-y-auto pl-1 border-l-2 border-gray-100">
//                 {filterOptions[group].map((value) => (
//                   <label
//                     key={value}
//                     className="flex items-center gap-2 text-sm text-gray-700 hover:text-gray-900 cursor-pointer"
//                   >
//                     <input
//                       type="checkbox"
//                       checked={selectedFilters[group].has(value)}
//                       onChange={() => toggleFilter(group, value)}
//                       className="rounded border-gray-300"
//                     />
//                     {value}
//                   </label>
//                 ))}
//               </div>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   </div>
// )}
//     </div>
//   );
// }

// src/components/ProductsPage.jsx

// import { useEffect, useState } from 'react';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import BackButton from './BackButton';
// import { useCategories } from '../context/CategoriesContext';
// import { useCart } from '../context/CartContext';
// import FilterDrawer from './FilterDrawer';

// export default function ProductsPage() {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [subcategoryName, setSubcategoryName] = useState('');
//   const [loadingPage, setLoadingPage] = useState(true);
//   const { cartItems, addToCart, updateQuantity } = useCart();

//   // Filter states
//   const [isFilterOpen, setIsFilterOpen] = useState(false);
//   const [selectedFilters, setSelectedFilters] = useState({
//     colour_group_name: new Set(),
//     department_name: new Set(),
//     garment_group_name: new Set(),
//     graphical_appearance_name: new Set(),
//     section_name: new Set(),
//   });

//   const subcategoryKey = searchParams.get('key');
//   const { categories, loading: loadingCategories } = useCategories();

//   // Reset filters when subcategory changes
//   useEffect(() => {
//     setSelectedFilters({
//       colour_group_name: new Set(),
//       department_name: new Set(),
//       garment_group_name: new Set(),
//       graphical_appearance_name: new Set(),
//       section_name: new Set(),
//     });
//   }, [subcategoryKey]);

//   // Load products
//   useEffect(() => {
//     if (!subcategoryKey || loadingCategories || !categories) return;

//     let found = false;
//     let productList = [];
//     let name = '';

//     for (const category of categories) {
//       for (const sub of category.subcategories) {
//         for (const child of sub.children) {
//           if (child.key === subcategoryKey) {
//             productList = child.products;
//             name = child.value;
//             found = true;
//             break;
//           }
//         }
//         if (found) break;
//       }
//       if (found) break;
//     }

//     if (found) {
//       setProducts(productList);
//       setSubcategoryName(name);
//     } else {
//       setSubcategoryName('Subcategory not found');
//     }

//     setLoadingPage(false);
//   }, [subcategoryKey, categories, loadingCategories]);

//   // Apply filters
//   useEffect(() => {
//     if (products.length === 0) return;

//     const filtered = products.filter((product) => {
//       const lowerName = product.name.toLowerCase();

//       for (const [key, values] of Object.entries(selectedFilters)) {
//         if (values.size === 0) continue;

//         const hasMatch = Array.from(values).some((value) =>
//           lowerName.includes(value.toLowerCase())
//         );
//         if (!hasMatch) return false;
//       }
//       return true;
//     });

//     setFilteredProducts(filtered);
//   }, [selectedFilters, products]);

//   // Handlers
//   const toggleFilter = (group, value) => {
//     setSelectedFilters((prev) => {
//       const newSet = new Set(prev[group]);
//       if (newSet.has(value)) {
//         newSet.delete(value);
//       } else {
//         newSet.add(value);
//       }
//       return { ...prev, [group]: newSet };
//     });
//   };

//   const clearFilters = () => {
//     setSelectedFilters({
//       colour_group_name: new Set(),
//       department_name: new Set(),
//       garment_group_name: new Set(),
//       graphical_appearance_name: new Set(),
//       section_name: new Set(),
//     });
//   };

//   if (loadingCategories || loadingPage) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">Loading products...</p>
//       </div>
//     );
//   }

//   if (!subcategoryKey || products.length === 0) {
//     return (
//       <div className="max-w-screen-xl mx-auto px-4 py-10 text-center">
//         <h2 className="text-2xl text-red-600">{subcategoryName}</h2>
//         <button
//           onClick={() => navigate(-1)}
//           className="mt-4 px-6 py-2 bg-gray-200 hover:bg-gray-300 rounded text-gray-800"
//         >
//           ← Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-screen-xl mx-auto px-4 py-10 relative">
//       <BackButton />

//       <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase tracking-tight">
//         {subcategoryName}
//       </h1>

//       {/* Category Tabs */}
//       <div className="flex flex-wrap gap-2 mb-6">
//         <button className="px-4 py-2 bg-black text-white font-medium text-sm uppercase tracking-wide rounded border border-black">
//           HOODIES & SWEATSHIRTS
//         </button>
//         <button className="px-4 py-2 bg-white text-gray-800 font-medium text-sm uppercase tracking-wide border border-gray-300 hover:bg-gray-100">
//           GRAPHIC HOODIES & SWEATSHIRTS
//         </button>
//       </div>

//       {/* Sort & Filter */}
//       <div className="flex justify-between items-center mb-6">
//         <button className="text-sm font-medium text-gray-700 flex items-center gap-1">
//           SORT BY
//           <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//           </svg>
//         </button>
//         <button
//           className="text-sm font-medium text-gray-700 flex items-center gap-1"
//           onClick={() => setIsFilterOpen(true)}
//         >
//           FILTER
//           <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00.293.707L18 17.586V19a1 1 0 01-1 1H7a1 1 0 01-1-1v-1.414l-6.414-6.414A1 1 0 013 12.586V4z" />
//           </svg>
//         </button>
//       </div>

//       {/* Product Grid */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
//         {filteredProducts.map((product) => {
//           const cartItem = cartItems.find((item) => item.id === product.id);
//           const quantity = cartItem ? cartItem.quantity : 0;

//           return (
//             <div
//               key={product.id}
//               className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden relative"
//             >
//               <img
//                 src={product.image}
//                 alt={product.name}
//                 className="w-full h-64 object-cover"
//               />

//               <div className="p-3">
//                 <h3 className="text-sm font-medium text-gray-800 line-clamp-2">
//                   {product.name}
//                 </h3>
//                 <p className="text-blue-600 font-semibold mt-1">
//                   ${product.price}
//                 </p>

//                 <div className="flex items-center justify-between mt-3">
//                   {quantity === 0 ? (
//                     <button
//                       onClick={() => addToCart(product)}
//                       className="w-full py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded transition-colors"
//                     >
//                       Add to Cart
//                     </button>
//                   ) : (
//                     <div className="flex items-center gap-2 w-full">
//                       <button
//                         onClick={() => updateQuantity(product.id, quantity - 1)}
//                         className="w-8 h-8 bg-gray-200 hover:bg-gray-300 rounded-full flex items-center justify-center text-sm"
//                       >
//                         −
//                       </button>
//                       <span className="flex-1 text-center text-sm font-medium">
//                         {quantity}
//                       </span>
//                       <button
//                         onClick={() => updateQuantity(product.id, quantity + 1)}
//                         className="w-8 h-8 bg-gray-200 hover:bg-gray-300 rounded-full flex items-center justify-center text-sm"
//                       >
//                         +
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {/* Use External Filter Drawer */}
//       <FilterDrawer
//         isFilterOpen={isFilterOpen}
//         onClose={() => setIsFilterOpen(false)}
//         selectedFilters={selectedFilters}
//         onFilterChange={toggleFilter}
//         onClearFilters={clearFilters}
//       />
//     </div>
//   );
// }

// src/components/ProductsPage.jsx
// src/components/ProductsPage.jsx

// import { useEffect, useState } from 'react';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import BackButton from './BackButton';
// import { useCategories } from '../context/CategoriesContext';
// import { useCart } from '../context/CartContext';
// import FilterDrawer from './FilterDrawer';
// import { fetchHomePageProducts } from '../api/homePageApi';

// export default function ProductsPage() {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const [products, setProducts] = useState([]);
//   const [loadingPage, setLoadingPage] = useState(true);
//   const [isFiltered, setIsFiltered] = useState(false); // Track if API results are shown

//   const subcategoryKey = searchParams.get('key');
//   const { categories, loading: loadingCategories } = useCategories();
//   const { cartItems, addToCart, updateQuantity } = useCart();

//   // Filter states
//   const [isFilterOpen, setIsFilterOpen] = useState(false);
//   const [selectedFilters, setSelectedFilters] = useState({
//     colour_group_name: new Set(),
//     department_name: new Set(),
//   });

//   // Reset on subcategory change
//   useEffect(() => {
//     setIsFiltered(false);
//     setSelectedFilters({
//       colour_group_name: new Set(),
//       department_name: new Set(),
//     });
//     loadCategoryProducts();
//   }, [subcategoryKey, categories]);

//   // Load products from categories (initial load)
//   const loadCategoryProducts = () => {
//     if (!subcategoryKey || loadingCategories || !categories.length) return;

//     let found = false;
//     let productList = [];

//     for (const category of categories) {
//       for (const sub of category.subcategories) {
//         for (const child of sub.children) {
//           if (child.key === subcategoryKey) {
//             productList = child.products || [];
//             found = true;
//             break;
//           }
//         }
//         if (found) break;
//       }
//       if (found) break;
//     }

//     if (found) {
//       setProducts(productList);
//       setLoadingPage(false);
//     } else {
//       setProducts([]);
//       setLoadingPage(false);
//     }
//   };

//   // Apply filters: Call API and replace products
//   const applyFilters = async () => {
//     const filters = {};
//     if (selectedFilters.colour_group_name.size > 0) {
//       filters.colour_group_name = Array.from(selectedFilters.colour_group_name).join(',');
//     }
//     if (selectedFilters.department_name.size > 0) {
//       filters.department_name = Array.from(selectedFilters.department_name).join(',');
//     }

//     if (Object.keys(filters).length === 0) {
//       // No filters → go back to category products
//       setIsFiltered(false);
//       loadCategoryProducts();
//       return;
//     }

//     try {
//       setLoadingPage(true);
//       const data = await fetchHomePageProducts({
//         ...filters,
//         page: 1,
//         per_page: 50
//       });

//       const mappedProducts = data.records.map(record => ({
//         id: record.article_id,
//         name: record.prod_name,
//         colour: record.colour_group_name,
//         department: record.department_name,
//         image: `https://picsum.photos/seed/${record.article_id}/400/600`,
//         price: Math.floor(Math.random() * 30) + 10, // Mock price
//       }));

//       setProducts(mappedProducts);
//       setIsFiltered(true);
//     } catch (err) {
//       console.error('Failed to load filtered products', err);
//     } finally {
//       setLoadingPage(false);
//       setIsFilterOpen(false);
//     }
//   };

//   // Clear filters → go back to category products
//   const clearFilters = () => {
//     setSelectedFilters({
//       colour_group_name: new Set(),
//       department_name: new Set(),
//     });
//     if (isFiltered) {
//       setIsFiltered(false);
//       loadCategoryProducts();
//     }
//   };

//   // Handle filter change
//   const toggleFilter = (group, value) => {
//     setSelectedFilters(prev => {
//       const newSet = new Set(prev[group]);
//       if (newSet.has(value)) {
//         newSet.delete(value);
//       } else {
//         newSet.add(value);
//       }
//       return { ...prev, [group]: newSet };
//     });
//   };

//   if (loadingCategories || loadingPage) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">Loading products...</p>
//       </div>
//     );
//   }

//   if (!subcategoryKey || products.length === 0) {
//     return (
//       <div className="max-w-screen-xl mx-auto px-4 py-10 text-center">
//         <h2 className="text-2xl text-red-600">No products found</h2>
//         <button
//           onClick={() => navigate(-1)}
//           className="mt-4 px-6 py-2 bg-gray-200 hover:bg-gray-300 rounded text-gray-800"
//         >
//           ← Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-screen-xl mx-auto px-4 py-10 relative">
//       <BackButton />

//       <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase tracking-tight">
//         {products[0]?.name.split(' ')[0] || 'Products'}
//       </h1>

//       {/* Sort & Filter */}
//       <div className="flex justify-between items-center mb-6">
//         <button className="text-sm font-medium text-gray-700 flex items-center gap-1">
//           SORT BY ▼
//         </button>
//         <button
//           className="text-sm font-medium text-gray-700 flex items-center gap-1"
//           onClick={() => setIsFilterOpen(true)}
//         >
//           FILTER
//         </button>
//       </div>

//       {/* Product Grid */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
//         {products.map((product) => {
//           const cartItem = cartItems.find((item) => item.id === product.id);
//           const quantity = cartItem ? cartItem.quantity : 0;

//           return (
//             <div key={product.id} className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden relative">
//               <img src={product.image} alt={product.name} className="w-full h-64 object-cover" />
//               <div className="p-3">
//                 <h3 className="text-sm font-medium text-gray-800 line-clamp-2">{product.name}</h3>
//                 <p className="text-blue-600 font-semibold mt-1">${product.price}</p>
//                 <div className="flex items-center justify-between mt-3">
//                   {quantity === 0 ? (
//                     <button
//                       onClick={() => addToCart(product)}
//                       className="w-full py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded transition-colors"
//                     >
//                       Add to Cart
//                     </button>
//                   ) : (
//                     <div className="flex items-center gap-2 w-full">
//                       <button
//                         onClick={() => updateQuantity(product.id, quantity - 1)}
//                         className="w-8 h-8 bg-gray-200 hover:bg-gray-300 rounded-full flex items-center justify-center text-sm"
//                       >
//                         −
//                       </button>
//                       <span className="flex-1 text-center text-sm font-medium">{quantity}</span>
//                       <button
//                         onClick={() => updateQuantity(product.id, quantity + 1)}
//                         className="w-8 h-8 bg-gray-200 hover:bg-gray-300 rounded-full flex items-center justify-center text-sm"
//                       >
//                         +
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {/* Filter Drawer */}
//       <FilterDrawer
//         isFilterOpen={isFilterOpen}
//         onClose={() => setIsFilterOpen(false)}
//         selectedFilters={selectedFilters}
//         onFilterChange={toggleFilter}
//         onClearFilters={clearFilters}
//         onApplyFilters={applyFilters}
//       />
//     </div>
//   );
// }

// src/components/ProductsPage.jsx

// import { useEffect, useState } from 'react';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import BackButton from './BackButton';
// import { useCategories } from '../context/CategoriesContext';
// import { useCart } from '../context/CartContext';
// import FilterDrawer from './FilterDrawer';
// import { fetchHomePageProducts } from '../api/homePageApi';

// export default function ProductsPage() {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const [products, setProducts] = useState([]);
//   const [loadingPage, setLoadingPage] = useState(true);
//   const [isFiltered, setIsFiltered] = useState(false);

//   const subcategoryKey = searchParams.get('key');
//   const { categories: apiData, loading: loadingCategories } = useCategories();
//   const { cartItems, addToCart, updateQuantity } = useCart();

//   // Filter states
//   const [isFilterOpen, setIsFilterOpen] = useState(false);
//   const [selectedFilters, setSelectedFilters] = useState({
//     colour_group_name: new Set(),
//     department_name: new Set(),
//   });

//   // Reset filters & reload on key change
//   useEffect(() => {
//     setIsFiltered(false);
//     setSelectedFilters({
//       colour_group_name: new Set(),
//       department_name: new Set(),
//     });
//     loadCategoryProducts();
//   }, [subcategoryKey, apiData]);

//   // Load products from API data (initial load)
//   const loadCategoryProducts = () => {
//     if (!subcategoryKey || loadingCategories || !apiData?.length) return;

//     // Parse key: "Ladies.Bags.Bag" → department = "Bags", type = "Bag"
//     const parts = subcategoryKey.split('.');
//     if (parts.length < 3) {
//       setProducts([]);
//       setLoadingPage(false);
//       return;
//     }

//     const departmentSlug = parts[1]; // "Bags"
//     const typeSlug = parts[2]; // "Bag"

//     // Decode and normalize
//     const departmentName = decodeURIComponent(departmentSlug.replace(/_/g, ' ').trim());
//     const productTypeName = decodeURIComponent(typeSlug.replace(/_/g, ' ').trim());

//     // Find department
//     const department = apiData.find(cat => cat.department_name === departmentName);
//     if (!department) {
//       setProducts([]);
//       setLoadingPage(false);
//       return;
//     }

//     // Find product type
//     const productType = department.product_types?.find(type => type.product_type_name === productTypeName);
//     if (!productType || !productType.products) {
//       setProducts([]);
//       setLoadingPage(false);
//       return;
//     }

//     // Map products
//     const mappedProducts = productType.products.map(p => ({
//       id: p.article_id,
//       name: p.prod_name,
//       price: parseFloat(p.price),
//       image: p.image_uri || `https://picsum.photos/seed/${p.article_id}/400/600`,
//       colour: p.colour_group_name || 'Unknown',
//       department: department.department_name,
//     }));

//     setProducts(mappedProducts);
//     setLoadingPage(false);
//   };

//   // Apply filters: Call API and replace products
//   const applyFilters = async () => {
//     const filters = {};
//     if (selectedFilters.colour_group_name.size > 0) {
//       filters.colour_group_name = Array.from(selectedFilters.colour_group_name).join(',');
//     }
//     if (selectedFilters.department_name.size > 0) {
//       filters.department_name = Array.from(selectedFilters.department_name).join(',');
//     }

//     if (Object.keys(filters).length === 0) {
//       // No filters → go back to category products
//       setIsFiltered(false);
//       loadCategoryProducts();
//       return;
//     }

//     try {
//       setLoadingPage(true);
//       const data = await fetchHomePageProducts({
//         ...filters,
//         page: 1,
//         per_page: 50
//       });

//       const mappedProducts = data.records.map(record => ({
//         id: record.article_id,
//         name: record.enhanced_prod_name,
//         price: parseFloat(record.price) || Math.floor(Math.random() * 30) + 10,
//         image: record.image_url ,
//         colour: record.colour_group_name,
//         department: record.department_name,
//       }));

//       setProducts(mappedProducts);
//       setIsFiltered(true);
//     } catch (err) {
//       console.error('Failed to load filtered products', err);
//       setProducts([]); // Show empty if error
//     } finally {
//       setLoadingPage(false);
//       setIsFilterOpen(false);
//     }
//   };

//   // Clear filters → go back to category products
//   const clearFilters = () => {
//     setSelectedFilters({
//       colour_group_name: new Set(),
//       department_name: new Set(),
//     });
//     if (isFiltered) {
//       setIsFiltered(false);
//       loadCategoryProducts();
//     }
//   };

//   // Handle filter change
//   const toggleFilter = (group, value) => {
//     setSelectedFilters(prev => {
//       const newSet = new Set(prev[group]);
//       if (newSet.has(value)) {
//         newSet.delete(value);
//       } else {
//         newSet.add(value);
//       }
//       return { ...prev, [group]: newSet };
//     });
//   };

//   if (loadingCategories || loadingPage) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <p className="text-xl text-gray-600">Loading products...</p>
//       </div>
//     );
//   }

//   if (!subcategoryKey || products.length === 0) {
//     return (
//       <div className="max-w-screen-xl mx-auto px-4 py-10 text-center">
//         <h2 className="text-2xl text-red-600">No products found</h2>
//         <button
//           onClick={() => navigate(-1)}
//           className="mt-4 px-6 py-2 bg-gray-200 hover:bg-gray-300 rounded text-gray-800"
//         >
//           ← Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-screen-xl mx-auto px-4 py-10 relative">
//       <BackButton />

//       <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase tracking-tight">
//         {products[0]?.name.split(' ')[0] || 'Products'}
//       </h1>

//       {/* Sort & Filter */}
//       <div className="flex justify-between items-center mb-6">
//         <button className="text-sm font-medium text-gray-700 flex items-center gap-1">
//           SORT BY ▼
//         </button>
//         <button
//           className="text-sm font-medium text-gray-700 flex items-center gap-1"
//           onClick={() => setIsFilterOpen(true)}
//         >
//           FILTER
//         </button>
//       </div>

//       {/* Product Grid */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
//         {products.map((product) => {
//           const cartItem = cartItems.find((item) => item.id === product.id);
//           const quantity = cartItem ? cartItem.quantity : 0;

//           return (
//             <div
//               key={product.id}
//               className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden relative"
//             >
//               <img
//                 src={product.image}
//                 alt={product.name}
//                 className="w-full h-64 object-cover"
//               />
//               <div className="p-3">
//                 <h3 className="text-sm font-medium text-gray-800 line-clamp-2">
//                   {product.name}
//                 </h3>
//                 <p className="text-blue-600 font-semibold mt-1">${product.price}</p>
//                 <div className="flex items-center justify-between mt-3">
//                   {quantity === 0 ? (
//                     <button
//                       onClick={() => addToCart(product)}
//                       className="w-full py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded transition-colors"
//                     >
//                       Add to Cart
//                     </button>
//                   ) : (
//                     <div className="flex items-center gap-2 w-full">
//                       <button
//                         onClick={() => updateQuantity(product.id, quantity - 1)}
//                         className="w-8 h-8 bg-gray-200 hover:bg-gray-300 rounded-full flex items-center justify-center text-sm"
//                       >
//                         −
//                       </button>
//                       <span className="flex-1 text-center text-sm font-medium">
//                         {quantity}
//                       </span>
//                       <button
//                         onClick={() => updateQuantity(product.id, quantity + 1)}
//                         className="w-8 h-8 bg-gray-200 hover:bg-gray-300 rounded-full flex items-center justify-center text-sm"
//                       >
//                         +
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {/* Filter Drawer */}
//       <FilterDrawer
//         isFilterOpen={isFilterOpen}
//         onClose={() => setIsFilterOpen(false)}
//         selectedFilters={selectedFilters}
//         onFilterChange={toggleFilter}
//         onClearFilters={clearFilters}
//         onApplyFilters={applyFilters}
//       />
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Chip,
  Rating,
  CircularProgress,
} from "@mui/material";

import FilterListIcon from "@mui/icons-material/FilterList";
import SortIcon from "@mui/icons-material/Sort";
import { useCategories } from "../context/CategoriesContext";
import FilterDrawer from "./FilterDrawer";
import { fetchHomePageProducts } from "../api/homePageApi";
import WishlistToggle from "./WishlistToggle";

export default function ProductsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [products, setProducts] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  const { loading: loadingCategories } = useCategories();
  const { products: passedProducts, subcategory, category } = location.state || {};

  // Filter states
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    colour_group_name: new Set(),
    department_name: new Set(),
  });

  // On first load: use passed products or fallback
 // In ProductsPage.jsx
useEffect(() => {
  if (location.state?.products) {
    
    setLoadingPage(true);
    const timer = setTimeout(() => {
      setProducts(location.state.products);
      setLoadingPage(false);
    }, 500);
    return () => clearTimeout(timer);
  } else {
    const key = searchParams.get("key");
    if (!key) navigate("/");
  }
}, [location.state, navigate, searchParams]);
  // Apply filters using API
  const applyFilters = async () => {
    const filters = {};
    if (selectedFilters.colour_group_name.size > 0) {
      filters.colour_group_name = Array.from(
        selectedFilters.colour_group_name
      ).join(",");
    }
    if (selectedFilters.department_name.size > 0) {
      filters.department_name = Array.from(
        selectedFilters.department_name
      ).join(",");
    }

    if (Object.keys(filters).length === 0) {
      setIsFiltered(false);
      setProducts(location.state?.products || []);
      setIsFilterOpen(false);
      return;
    }

    setLoadingPage(true);
    try {
      const data = await fetchHomePageProducts({
        ...filters,
        page: 1,
        per_page: 50,
      });

      const mappedProducts = data.records.map((record) => {
        const price = parseFloat(record.price) || 0;
        const discountedPrice = parseFloat(record.discounted_price) || price;
        const isOnPromotion = discountedPrice < price;

        return {
          id: record.article_id,
          name: record.enhanced_prod_name || record.prod_name,
          detail_desc: record.detail_desc || "No description available.",
          price: price,
          discounted_price: discountedPrice,
          isOnPromotion: isOnPromotion,
          image: record.image_url
            ?.replace("storage.cloud.google.com", "storage.googleapis.com")
            .trim(),
          colour: record.colour_group_name || "Unknown",
          department: record.department_name,
          rating: Math.random() * 2 + 3, // Mock rating
          reviews: Math.floor(Math.random() * 100) + 1, // Mock reviews
        };
      });

      setProducts(mappedProducts);
      setIsFiltered(true);
    } catch (err) {
      console.error("Failed to load filtered products", err);
      setProducts([]);
    } finally {
      setLoadingPage(false);
      setIsFilterOpen(false);
    }
  };

  const clearFilters = () => {
    setSelectedFilters({
      colour_group_name: new Set(),
      department_name: new Set(),
    });
    if (isFiltered) {
      setIsFiltered(false);
      setProducts(location.state?.products || []);
    }
  };

  const toggleFilter = (group, value) => {
    setSelectedFilters((prev) => {
      const newSet = new Set(prev[group]);
      if (newSet.has(value)) {
        newSet.delete(value);
      } else {
        newSet.add(value);
      }
      return { ...prev, [group]: newSet };
    });
  };

  const handleProductClick = (product) => {
    if (!product?.id) return;
    navigate(`/item/${product.id}`);
  };

  // Product Card Component matching Figma design
  const ProductCard = ({ product, badge }) => {
    // Add rating and reviews if not present
    const displayProduct = {
      ...product,
      rating: product.rating || Math.random() * 2 + 3,
      reviews: product.reviews || Math.floor(Math.random() * 100) + 1,
    };

    return (
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          cursor: "pointer",
          transition: "all 0.3s ease",
          position: "relative",
          borderRadius: 2,
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 8px 16px rgba(0,0,0,0.12)",
          },
        }}
        onClick={() => handleProductClick(product)}
      >
        {/* Badge */}
        {badge && (
          <Chip
            label={badge}
            size="small"
            sx={{
              position: "absolute",
              top: 12,
              left: 12,
              zIndex: 1,
              bgcolor:
                badge === "Sale" || badge === "SALE"
                  ? "#FF4444"
                  : badge === "New"
                  ? "#4CAF50"
                  : "#9C27B0",
              color: "white",
              fontWeight: 600,
              fontSize: "0.7rem",
              height: 24,
            }}
          />
        )}

        {/* Product Image */}
        <CardMedia
          component="img"
          image={product.image || `https://picsum.photos/seed/${product.id}/400/600`}
          alt={product.name}
          sx={{
            objectFit: "cover",
            height: 320,
            bgcolor: "#f5f5f5",
          }}
          onError={(e) => {
            e.target.src = `https://picsum.photos/seed/${product.id}/400/600`;
          }}
        />

        {/* Product Info */}
        <CardContent sx={{ flexGrow: 1, p: 2, pb: 2.5 }}>
          {/* Product Name */}
       <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start", // allows title to wrap while heart stays top-aligned
            mb: 1,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 500,
              color: "text.primary",
              flex: 1,
              mr: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            {product.name}
          </Typography>
          {/* ✅ Wishlist Toggle — inline, right-aligned */}
          <Box sx={{ flexShrink: 0, mt: '-2px' }}>
            <WishlistToggle product={product} />
          </Box>
        </Box>

          {/* Rating */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Rating
              value={displayProduct.rating}
              precision={0.1}
              size="small"
              readOnly
              sx={{
                color: "#FFB400",
                fontSize: "1rem",
              }}
            />
            <Typography
              variant="caption"
              sx={{ ml: 0.5, color: "#666", fontSize: "0.75rem" }}
            >
              ({displayProduct.reviews})
            </Typography>
          </Box>

          {/* Price */}
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mb: 1.5 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: product.isOnPromotion ? "#FF4444" : "#1a1a1a",
                fontSize: "1.125rem",
              }}
            >
              ${product.isOnPromotion ? product.discounted_price.toFixed(2) : product.price.toFixed(2)}
            </Typography>
            {product.isOnPromotion && (
              <Typography
                variant="body2"
                sx={{
                  textDecoration: "line-through",
                  color: "#999",
                  fontSize: "0.875rem",
                }}
              >
                ${product.price.toFixed(2)}
              </Typography>
            )}
          </Box>

          {/* Size Options */}
          <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
            {["S", "M", "L", "XL"].map((size) => (
              <Box
                key={size}
                sx={{
                  width: 26,
                  height: 26,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  fontSize: "0.7rem",
                  color: "#666",
                  fontWeight: 500,
                  "&:hover": {
                    borderColor: "#999",
                    bgcolor: "#f5f5f5",
                  },
                }}
              >
                {size}
              </Box>
            ))}
          </Box>
        </CardContent>
      </Card>
    );
  };

  if (loadingCategories || loadingPage) {
    const loadingLabel =
      category && subcategory
        ? `${category} – ${subcategory}`
        : category
        ? category
        : "products";
    return (
      <Container maxWidth="xl" sx={{ py: 8, textAlign: "center" }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2, color: "text.secondary" }}>
          Loading {loadingLabel}...
        </Typography>
      </Container>
    );
  }


  return (
    <Container maxWidth="xl" sx={{ py: 4, px: { xs: 2, sm: 3 } }}>
      {/* Back Button */}
     

      {/* Page Title */}
      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          mb: 4,
          color: "#1a1a1a",
          textTransform: "uppercase",
          letterSpacing: "-0.5px",
          fontSize: { xs: "2rem", md: "2.5rem" },
        }}
      >
        {subcategory
          ? subcategory.toUpperCase()
          : category
          ? category.toUpperCase()
          : passedProducts?.[0]?.name?.split(" ")[0] || "Products"}
      </Typography>

      {/* Filter and Sort Bar */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Button
          startIcon={<SortIcon />}
          variant="outlined"
          size="small"
          sx={{
            borderColor: "#ddd",
            color: "#666",
            textTransform: "none",
            fontWeight: 500,
            "&:hover": {
              borderColor: "#999",
              bgcolor: "rgba(0,0,0,0.02)",
            },
          }}
        >
          SORT BY
        </Button>

        <Button
          startIcon={<FilterListIcon />}
          variant="outlined"
          size="small"
          onClick={() => setIsFilterOpen(true)}
          sx={{
            borderColor: "#ddd",
            color: "#666",
            textTransform: "none",
            fontWeight: 500,
            "&:hover": {
              borderColor: "#999",
              bgcolor: "rgba(0,0,0,0.02)",
            },
          }}
        >
          FILTER
        </Button>
      </Box>

      {/* Product Grid */}
      <Grid container spacing={3}>
        {products.map((product, index) => (
          <Grid item xs={6} sm={4} md={3} lg={2.4} key={product.id}>
            <ProductCard
              product={product}
              badge={
                product.isOnPromotion
                  ? "SALE"
                  : index % 7 === 0
                  ? "New"
                  : index % 11 === 0
                  ? "Restocked"
                  : null
              }
            />
          </Grid>
        ))}
      </Grid>

      {/* Filter Drawer */}
      <FilterDrawer
        isFilterOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        selectedFilters={selectedFilters}
        onFilterChange={toggleFilter}
        onClearFilters={clearFilters}
        onApplyFilters={applyFilters}
      />
    </Container>
  );
}